/* eslint-disable */
import React from 'react'
import { useUpdate } from 'react-three-fiber'
import Color from '../../Utilities/Colors/ColorMap'

export default function SprayPoint({
    settings,
    coords,
    legendField,
    z,
    lastUpdate,
    isFinished,
    chartOptions,
}) {
    const updateGeometry = useUpdate((geometry) => {
        for (let i = 0; i < geometry.faces.length; i++) {
            if (geometry.faces[i].normal.y === 0) {
                geometry.faces[i].color.setHex(0x111111)
            }
        }
    }, [])

    return (
        <mesh
            key="spray"
            visible
            position={[coords.x, coords.y, z]}
            rotation={[Math.PI / 2, 0, 0]}
            onUpdate={() => {
                isFinished(lastUpdate)
            }}
        >
            <cylinderGeometry
                ref={updateGeometry}
                attach="geometry"
                args={[8, 8, 4, 16]}
            />
            <meshPhongMaterial
                attach="material"
                vertexColors="#000000"
                color={Color(chartOptions.legendType, legendField)}
            />
        </mesh>
    )
}
